import { MouseButton } from '@/types/types';
import { ProjectRenderer } from '../ProjectRenderer';
import { CursorHandler } from './CursorHandler';
import { Object3D, Raycaster, Vector2 } from 'three';
import RENDERER_CONFIG from '@/configs/rendererConfig';

export class Mouse {
	private mouse = new Vector2();
	private mouseDown = new Vector2();
	private raycaster = new Raycaster();
	private enabled = true;
	cursorHandler: CursorHandler;
	hoveredObject: Object3D | null = null;

	constructor(private renderer: ProjectRenderer) {
		this.renderer = renderer;
		this.mouseMove = this.mouseMove.bind(this);
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onMouseUp = this.onMouseUp.bind(this);

		this.cursorHandler = new CursorHandler(renderer, this);
	}

	init() {
		this.raycaster.layers.disableAll();

		this.renderer.canvas!.addEventListener('mousemove', this.mouseMove);
		this.renderer.canvas!.addEventListener('mousedown', this.onMouseDown);
		this.renderer.canvas!.addEventListener('mouseup', this.onMouseUp);
	}

	private mouseMove(event: MouseEvent) {
		event.preventDefault();
		if (!this.enabled) return;

		const rect = this.renderer.canvas!.getBoundingClientRect();
		this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
		this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

		this.raycaster.setFromCamera(
			this.mouse,
			this.renderer.cameraController.camera
		);

		this.checkIntersections();

		this.cursorHandler.setCursorType();
	}

	private onMouseDown(event: MouseEvent) {
		if (!this.enabled) return;

		this.mouseDown.copy(this.mouse);

		if (event.button === MouseButton.MIDDLE) {
			return;
		}
		if (event.button === MouseButton.RIGHT) {
			return;
		}
	}

	private onMouseUp(event: MouseEvent) {
		event.preventDefault();
		if (!this.enabled) return;

		const dist = this.mouseDown.distanceTo(this.mouse);

		this.mouseDown.set(0, 0);

		if (event.button === MouseButton.RIGHT) {
			if (dist < RENDERER_CONFIG.MOUSE.UNSELECT_DISTANCE) return;
		}
	}

	private checkIntersections() {
		const intersects = this.raycaster.intersectObjects(
			this.renderer.project.children
		);

		const intersectedObject = intersects[0]?.object;

		if (!intersectedObject) {
			this.hoveredObject = null;
			return;
		}

		this.hoveredObject = intersectedObject;
		this.handleIntersection();
	}

	private handleIntersection() {
		if (!this.hoveredObject) return;
	}
}
